import React from "react"
import "./QuantityField.css"
import { ArrowUpIcon, ArrowDownIcon } from "../../Icons"
import PropTypes from "prop-types"

class QuantityField extends React.Component {
  handleChange = e => {
    const { name } = this.props.field
    const { setFieldValue, setFieldTouched } = this.props.form
    const val = e.target.value
    setFieldValue(name, val)
    setFieldTouched(name)
  }

  handleBlur = e => {
    const { name } = this.props.field
    const { setFieldValue, setFieldTouched } = this.props.form
    let val = 0
    const inputValue = Number(e.target.value)
    const max = this.props.max
    const min = this.props.min
    if (!isNaN(inputValue) && inputValue !== "") {
      if (inputValue <= max && inputValue >= min) {
        val = inputValue
      } else {
        if (inputValue > max) val = max
        if (inputValue < min) val = min
      }
    } else {
      val = 0
    }
    setFieldValue(name, val)
    setFieldTouched(name)
  }

  tickUp = () => {
    const { name } = this.props.field
    const { setFieldValue, setFieldTouched } = this.props.form
    const max = this.props.max || 999999999
    const val =
      parseInt(this.props.value) + 1 > max
        ? max
        : parseInt(this.props.value) + 1
    setFieldValue(name, val)
    setFieldTouched(name)
  }

  tickDown = () => {
    const { name } = this.props.field
    const { setFieldValue, setFieldTouched } = this.props.form
    const min = this.props.min || -999999999
    const val =
      parseInt(this.props.value) - 1 < min
        ? min
        : parseInt(this.props.value) - 1
    setFieldValue(name, val)
    setFieldTouched(name)
  }

  renderError = () => {
    const {
      field,
      form: { touched, errors }
    } = this.props

    if (field.name.includes(".")) {
      const fieldName = field.name.split(".")[0]
      const fieldIndex = field.name.split(".")[1]
      if (
        touched[fieldName] &&
        touched[fieldName][fieldIndex] &&
        errors[fieldName] &&
        errors[fieldName][fieldIndex]
      ) {
        return (
          <div className="error-message">{errors[fieldName][fieldIndex]}</div>
        )
      } else {
        return null
      }
    } else {
      if (touched[field.name] && errors[field.name]) {
        return <div className="error-message">{errors[field.name]}</div>
      } else {
        return null
      }
    }
  }

  render() {
    const {
      field,
      form: { touched, errors },
      ...props
    } = this.props
    let status = "default"
    // Check first if Field Array
    if (field.name.includes(".")) {
      const fieldName = field.name.split(".")[0]
      const fieldIndex = field.name.split(".")[1]
      if (
        touched[fieldName] &&
        touched[fieldName][fieldIndex] &&
        errors[fieldName] &&
        errors[fieldName][fieldIndex]
      ) {
        status = "has-error"
      } else if (
        touched[fieldName] &&
        touched[fieldName][fieldIndex] &&
        field.value &&
        errors[fieldName] &&
        errors[fieldName][fieldIndex]
      ) {
        status = "is-fixed"
      }
    } else {
      if (touched[field.name] && errors[field.name]) {
        status = "has-error"
      } else if (touched[field.name] && field.value && !errors[field.name]) {
        status = "is-fixed"
      }
    }
    return (
      <div className={`QuantityField ${status}`}>
        <div className="field-area">
          <div className="field-grid">
            <span className="value">
              <input
                type="number"
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                onFocus={this.props.onFocus}
                value={this.props.value}
                max={this.props.max}
                min={this.props.min}
                {...props}
              />
            </span>
            <span className="quantity-buttons">
              <span onClick={this.tickUp}>
                <ArrowUpIcon />
              </span>
              <span onClick={this.tickDown}>
                <ArrowDownIcon />
              </span>
            </span>
          </div>
        </div>
        {this.renderError()}
      </div>
    )
  }
}

QuantityField.propTypes = {
  handleChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  min: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

QuantityField.defaultProps = {
  value: 0,
  max: 999999999,
  min: -999999999
}

export default QuantityField
